export default __webpack_public_path__ + "static/media/todo.0a4b68c0.png";